import React from 'react';

export function ChartSummary({ data }) {
  const datasets = (data?.datasets || []).filter(dataset => !dataset.hidden);
  if (!datasets.length) return null;
  const points = datasets.flatMap(dataset => dataset.data || []).filter(value => typeof value === 'number' && Number.isFinite(value));
  if (!points.length) return null;
  const format = value => value.toLocaleString(undefined, {maximumFractionDigits: 2});
  return <p className="col-span-full px-4 py-2 text-sm text-slate-600" aria-label="Chart summary">
    {datasets.length === 1 ? datasets[0].label || 'Selected series' : `${datasets.length} selected series`}: {points.length.toLocaleString()} available values, ranging from {format(Math.min(...points))} to {format(Math.max(...points))}.
  </p>;
}
